import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Topbar from "../../components/topbar/Topbar";
import classes from "./Prizes.module.css";
import Sidebar from "../../components/sidebar/Sidebar";
import SidebarContext from "../../store/SidebarContext";
import Page from "../../components/DefaultPage/DefaultPage";
import { AddPrizeCard, PrizeCard } from "../../components/Cards/Cards";
import LoadingPage from "../LoadingPage/LoadingPage";

function Prizes() {
  const sidebarCtx = useContext(SidebarContext);
  const isSidebar = sidebarCtx.sidebar;
  const [isLoading, setIsLoading] = useState(false);
  const [loadedPrizes, setLoadedPrizes] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("valid"); // "valid" ou "all"
  const [tg, i18n] = useTranslation("global");

  const ip = process.env.REACT_APP_SERVER_IP;
  const port = process.env.REACT_APP_SERVER_PORT;
  const protocol = process.env.REACT_APP_SERVER_PROTOCOL;
  const serverPath = `${protocol}://${ip}:${port}`;

  const prizesPath =
    selectedFilter === "valid"
      ? `${serverPath}/prizes`
      : `${serverPath}/all-prizes`;

  useEffect(() => {
    setIsLoading(true);
    fetch(prizesPath)
      .then((response) => response.json())
      .then((prizes) => {
        setIsLoading(false);
        setLoadedPrizes(Object.values(prizes));
      })
      .catch((error) => {
        console.error("Error fetching prizes:", error);
        setIsLoading(false);
      });
  }, [prizesPath]);

  if (isLoading) {
    return (
      <section>
        <LoadingPage />
      </section>
    );
  }

  return (
    <Page>
      <section className={classes.cards} style={{ marginTop: "5rem" }}>
        {/* Cabeçalho com botão de adicionar + filtro */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: "1rem",
          }}
        >
          <ul style={{ margin: 0 }}>
            <li>
              <AddPrizeCard image="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Plus_symbol.svg/1200px-Plus_symbol.svg.png" />
            </li>
          </ul>

          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <label htmlFor="filterSelect" style={{ fontWeight: "bold" }}>
              Filtrar:
            </label>
            <select
              id="filterSelect"
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.target.value)}
              style={{
                padding: "0.5rem",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontWeight: "bold",
              }}
            >
              <option value="valid">Válidos</option>
              <option value="all">Todos</option>
            </select>
          </div>
        </div>

        {/* Lista de prémios ou mensagem se não houver nenhum */}
        {loadedPrizes.length === 0 ? (
          <p style={{ fontWeight: "bold", textAlign: "center", marginTop: "2rem" }}>
            {selectedFilter === "valid"
              ? "Não existe nenhum prémio ativo no momento"
              : "Não existe nenhum prémio listado"}
          </p>
        ) : (
          <ul>
            {loadedPrizes.map((prize) => (
              <li key={prize.id}>
                <PrizeCard
                  id={prize.id}
                  wallet={prize.wallet}
                  title={prize.title}
                  pointValue={prize.pointValue}
                  dueDate={prize.dueDate}
                  image={prize.image}
                  description={prize.description}
                  availability={prize.quantity}
                  maxPerUser={prize.maxPerUser}
                />
              </li>
            ))}
          </ul>
        )}
      </section>
    </Page>
  );
}

export default Prizes;
